import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { hydrateFunnelFromUrl } from './lib/funnel'
import './styles/index.css'

// Handoff externo (calculadora de distrato → Resolve): preenche o funil antes do render.
hydrateFunnelFromUrl()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
